import moment from 'moment';
import '@/assets/styles/rating.scss';
import { pickerOptions } from '@/common/pickerOptions';
import localReferences from '@/helpers/localReferences';

export default {
    data() {
        return {
            loading: false,
            pickerOptions,
            localReferences,
            officeId: localReferences.offices.all,
            daysRange: [
                moment().startOf('month').format('DD.MM.YYYY'),
                moment().endOf('month').format('DD.MM.YYYY')
            ]
        };
    },
    mounted() {
        this.getRating();
    },
    methods: {
        getShadowClass(employer, key) {
            let resultClass = '';

            if ((key === 'sales' && Number(employer.salesPercent) === 0) || (key === 'implementation' && Number(employer.implementationPercent) === 0) || (key === 'efficiency' && Number(employer.efficiencyPercent) === 0)) {
                resultClass = 'empty';
            }

            return resultClass;
        },
        getRowClass(index, length) {
            let rowClass = '';

            if (length) {
                if ([0, 1, 2].includes(index)) {
                    rowClass = 'high';
                }

                if (length > 3 && length < 7 && index > 2) {
                    rowClass = 'low';
                }
                if (length > 6) {
                    if ([length - 1, length - 2, length - 3].includes(index)) {
                        rowClass = 'low';
                    }
                }
            }

            return rowClass;
        },
        getCellOuterStyle(employer, key, rating, length) {
            let percent = null;
            if (key === 'sales') {
                percent = employer.salesPercent;
            }
            if (key === 'implementation') {
                percent = +employer.implementationPercent < 100 ? employer.implementationPercent : 100;
            }
            if (key === 'efficiency') {
                percent = +employer.efficiencyPercent < 100 ? employer.efficiencyPercent : 100;
            }
            if (percent) {
                let color = '#dcece9';
                let backColor = '#1cd506';
                if (rating > 3) {
                    color = '#f8f2df';
                    backColor = '#ffa54c';
                }
                if ((length - rating) < 3 && rating > 3) {
                    color = '#f4dfdf';
                    backColor = '#ce3137';
                }
                return {
                    'background-image': `linear-gradient(to right, ${backColor} ${percent}%, ${color} ${percent}%)`
                };
            }
            return {};
        },
        getPercentNoValueStyle(percent, rating, length) {
            let color = '#1cd506';
            if (rating > 3) {
                color = '#ffa54c';
            }
            if ((length - rating) < 3 && rating > 3) {
                color = '#ce3137';
            }
            return {
                'background': 'none!important',
                'color': color
            };
        },
        getCellInnerStyle(employer, key, rating, length) {
            let percent = null;

            if (key === 'sales') {
                percent = employer.salesPercent;
                if (Number(percent) === 0) {
                    return {
                        'background': 'none!important',
                        'color': '#000'
                    };
                }
            }
            if (key === 'implementation') {
                percent = +employer.implementationPercent < 100 ? employer.implementationPercent : 100;
                if (Number(percent) === 0) {
                    return this.getPercentNoValueStyle(percent, rating, length);
                }
            }
            if (key === 'efficiency') {
                percent = +employer.efficiencyPercent < 100 ? employer.efficiencyPercent : 100;
                if (Number(percent) === 0) {
                    return this.getPercentNoValueStyle(percent, rating, length);
                }
            }
            if (percent) {
                let backColor = '#1cd506';
                if (rating > 3) {
                    backColor = '#ffa54c';
                }
                if ((length - rating) < 3 && rating > 3) {
                    backColor = '#ce3137';
                }
                return {
                    'background-image': `linear-gradient(to right, #fff ${percent}%, ${backColor} ${percent}%)`
                };
            }
            return {};
        },
        getTotalCellOuterStyle(total, key) {
            let percent = null;
            if (key === 'sales' && total.salesPercent) {
                percent = total.salesPercent;
            }
            if (key === 'implementation') {
                percent = +total.implementationPercent < 100 ? total.implementationPercent : 100;
            }
            if (key === 'efficiency') {
                percent = +total.efficiencyPercent < 100 ? total.efficiencyPercent : 100;
            }
            if (percent) {
                const color = '#fff';
                const backColor = '#ffa54c';
                return {
                    'background-image': `linear-gradient(to right, ${backColor} ${percent}%, ${color} ${percent}%)`
                };
            }
            return {};
        },
        getTotalCellInnerStyle(total, key) {
            let percent = null;
            if (key === 'sales' && total.salesPercent) {
                percent = total.salesPercent;
            }
            if (key === 'implementation') {
                percent = +total.implementationPercent < 100 ? total.implementationPercent : 100;
            }
            if (key === 'efficiency') {
                percent = +total.efficiencyPercent < 100 ? total.efficiencyPercent : 100;
            }
            if (percent) {
                const backColor = '#ffa54c';
                return {
                    'background-image': `linear-gradient(to right, #fff ${percent}%, ${backColor} ${percent}%)`
                };
            }
            return {};
        },
        openGrid(gridType, ids) {
            if (!ids || !ids.length) {
                return;
            }
            if (gridType === 'deals') {
                this.$store.commit('analytics/setDealIds', ids);
                this.$router.push({ name: 'analytics-employers-rating-deals' });
            }
            if (gridType === 'leads') {
                this.$store.commit('analytics/setLeadIds', ids);
                this.$router.push({ name: 'analytics-employers-rating-leads' });
            }
        },
        isFiredEmployerClass(dateFired) {
            return dateFired ? 'fired_employer' : '';
        }
    }
};
